import { useEffect, useState } from 'react';

export function useGetVideoSignature(clipId: string | number) {
  const [signature, setSignature] = useState<string | undefined>(undefined);
  useEffect(() => {
    const signatureMetaTag = document.querySelector(`meta[name="video-signature-${clipId}"]`);
    if (signatureMetaTag) {
      setSignature(signatureMetaTag.getAttribute('content') ?? '');
    }
  }, [clipId]);

  return signature;
}
